export const randomNumber = (max = 10000) => {
  const num = Math.floor(Math.random() * max);
  return num;
};
